import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import PageBlocksForm from "components/form/PageBlocksForm";
import PageForm from "components/form/PageForm";

import { SaveContextProvider } from "context/save";

import { usePageId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Pagina modificata con successo",
        errorMsg: "Errore nella modifica della pagina",
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaPagina() {
    const pageId = usePageId();

    return (
        <GridColumn>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Modifica Pagina</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <PageForm pageId={pageId} />

                <PageBlocksForm pageId={pageId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaPagina;
